import React from 'react';
import { RowEdit } from '../../common/DataTable/RowEdit';
import { HeaderMenu } from './HeaderMenu';
import { Grid, Link, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { DL_COURSE_TYPE_Z } from '../../common/constants';
import { RowCheckbox } from '../../common/DataTable/RowCheckbox';

export const getColumns = ({ id, courses, selectionModel, setSelectionModel, courseMenu }) => [
  {
    field: 'edit',
    headerName: '',
    width: 65,
    sortable: false,
    disableColumnMenu: true,
    resizable: false,
    cellClassName: 'edit-cell',
    headerClassName: 'edit-cell-header',
    renderCell: (params) => {
      return (
        params.row.TYPE === DL_COURSE_TYPE_Z && (
          <RowEdit rowData={params.row} actions={courseMenu} />
        )
      );
    },
  },
  {
    field: 'select',
    headerName: '',
    width: 65,
    sortable: false,
    disableColumnMenu: true,
    resizable: false,
    renderHeader: () => (
      <HeaderMenu
        id={`${id}HeaderMenu`}
        selectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
        courses={courses}
      />
    ),
    renderCell: (params) => {
      const rowId = params.row.CRN;

      const isSelected = !!selectionModel[rowId];

      const handleChange = (event) => {
        if (event.target.checked) {
          selectionModel[rowId] = params.row;
          // Add this row to the selection
          setSelectionModel({ ...selectionModel });
        } else {
          // Remove this row from the selection
          setSelectionModel((prev) => {
            delete prev[rowId];
            return { ...prev };
          });
        }
      };

      return <RowCheckbox isSelected={isSelected} handleChange={handleChange} />;
    },
  },
  {
    field: 'TYPE',
    headerName: 'Type',
    width: 90,
  },
  {
    field: 'CRN',
    headerName: 'Min CRN',
    renderCell: (params) => {
      return (
        <Link
          href={`/ats/courses/${params.row.TERM_CODE}/${params.row.CRN}`}
          id={`${id}__link_${params.row.TERM_CODE}_${params.row.CRN}`}
        >
          {params.row.CRN}
        </Link>
      );
    },
  },
  {
    field: 'codecs',
    headerName: 'Codecs',
    width: 320,
    renderCell: (params) => (
      <>
        {params.row.codecs?.map((codec, index) => {
          return (
            <Grid id={`${id}__grid_container_${index}`} key={index} container>
              <Grid id={`${id}__grid_item_systemName_${index}`} item flexGrow={1}>
                <Typography id={`${id}__text_systemName_${index}`} variant="small">
                  {codec.systemName}
                </Typography>
              </Grid>
              <Grid item id={`${id}__grid_item_date_${index}`}>
                <Typography id={`${id}__text_date_${index}`} variant="small">
                  {dayjs(codec.startDate).format('MM/DD')}
                  {' - '}
                  {dayjs(codec.endDate).format('MM/DD')}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </>
    ),
  },
  {
    field: 'CRNS',
    headerName: 'CRNs',
    width: 225,
  },
  {
    field: 'SUBJECT_CODE',
    headerName: 'Subject',
  },
  {
    field: 'COURSE_NUMBER',
    headerName: 'Course Number',
    width: 130,
  },
  {
    field: 'COURSE_TITLE',
    headerName: 'Title',
    width: 250,
  },
  {
    field: 'INSTRUCTOR_NAME',
    headerName: 'Instructor',
    width: 200,
  },
  {
    field: 'INSTRUCTOR_EMAIL',
    headerName: 'Email',
    width: 200,
  },
  {
    field: 'INSTRUCTOR_MIDAS_ID',
    headerName: 'Midas Id',
  },
  {
    field: 'OTHER_INSTRUCTORS',
    headerName: 'Other Instructors',
    width: 150,
  },
  {
    field: 'BUILDING_CODE',
    headerName: 'Building',
  },
  {
    field: 'ROOM_CODE',
    headerName: 'Room',
  },
  {
    field: 'MEETING_DAYS',
    headerName: 'Days',
  },
  {
    field: 'START_DATE',
    headerName: 'Start Date',
  },
  {
    field: 'END_DATE',
    headerName: 'End Date',
  },
  {
    field: 'BEGIN_TIME',
    headerName: 'Begin Time',
  },
  {
    field: 'END_TIME',
    headerName: 'End Time',
  },
  {
    field: 'TERM_CODE',
    headerName: 'Term',
  },
];

export const getCodecsColumns = (id, isSmall = false) => [
  {
    field: 'systemName',
    headerName: 'System Name',
    width: 200,
  },
  {
    field: 'codecsId',
    headerName: 'ID',
    width: isSmall ? 250 : undefined,
    flex: !isSmall ? 1 : undefined,
  },
  {
    field: '',
    headerName: 'Start Date - End Date',
    width: 200,
    renderCell: (params) => (
      <Typography id={`${id}__text_codecs_date`} variant="small">
        {dayjs(params.row.startDate).format('YYYY/MM/DD')}
        {' - '}
        {dayjs(params.row.endDate).format('YYYY/MM/DD')}
      </Typography>
    ),
  },
];
